module.exports = __webpack_public_path__ + "img/content-with-img-links-toyota.a8ab1151.jpg";